import React, { useState } from 'react';
import styled from 'styled-components';
import { Accordion, AccordionDetails, AccordionSummary, LinearProgress } from '@mui/material';
import cx from 'classnames';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BusinessDisplayUnit } from '../../../types/business-group-type';
import {
    getBusinessDisplayUnit,
    GetBusinessDisplayUnitResult,
} from '../../../services/business-group.service';
import BusinessListUnitItem from '../BusinessListUnitItem/BusinessListUnitItem';
import DefaultBusinessIcon from '../../common/Icons/default-business-icon';

interface BusinessGroupListItemProps {
    businessGroup: BusinessDisplayUnit;
    onSelect: (businessDisplayUnit: BusinessDisplayUnit) => void;
}

const StyledBusinessGroupListItem = styled.div`
    border-top: 1px solid #e4dee4;
    .accordion-bgc {
        background-color: rgba(17, 17, 17, 5%);
    }
    .gray-boder {
        border-top: 1px solid gray;
    }
`;

const StyleBusinessGroupListItemTitle = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    align-items: center;
    //padding-left: 23px;
    .business-group-logo {
        max-width: 50px;
        max-height: 50px;
        align-self: center;
    }
    .default-business-log {
        width: 50px;
        height: 50px;
    }
    .business-group-list-description {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        padding-left: 20px;
        overflow: hidden;
    }
    .business-group-log {
        width: 50px;
        height: 50px;
    }

    .business-name {
        height: auto;
        width: 280px;
        //text-overflow: ellipsis;
        //overflow: hidden;
        min-width: 0;
        //white-space: nowrap;
        padding-top: 5px;
    }
    .description {
        color: #787878;
        height: auto;
        width: 280px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding-top: 5px;
        //display: -webkit-box;
        //-webkit-box-orient: vertical;
        //-webkit-line-clamp: 2;
    }
`;
const StyledAccordion = styled(Accordion)`
    box-shadow: none;
    border: none;
`;
const StyleAccordionSummary = styled(AccordionSummary)`
    height: calc(100% - 20px);
    padding-top: 0px;
    padding-left: 22px;
    border: none;
    .business-name {
        font-weight: bold;
    }
`;
const StyleAccordionDetails = styled(AccordionDetails)`
    display: flex;
    border: none;
    flex-direction: column;
    background-color: rgba(17, 17, 17, 5%);
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 32px;

    .no-business-text {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
    }
`;
const BusinessGroupListItem = ({ businessGroup, onSelect }: BusinessGroupListItemProps) => {
    const [businessDisplayUnitList, setBusinessDisplayUnitList] = useState<BusinessDisplayUnit[]>(
        [],
    );
    const [isFetchMore, setIsFetchMore] = useState<boolean>(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const fetchBusinessItem = async () => {
        setIsFetchMore(true);
        const payLoad = {
            businessDisplayGroupId: businessGroup.id,
        };
        const result: GetBusinessDisplayUnitResult = await getBusinessDisplayUnit(payLoad);
        if (result.data) {
            setBusinessDisplayUnitList(result.data.businessDisplayUnitList);
        }
        setIsFetchMore(false);
    };
    const handleChange = (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        if (isExpanded) {
            setIsExpanded(true);
            fetchBusinessItem();
        } else {
            setIsExpanded(false);
        }
    };
    return (
        <StyledBusinessGroupListItem>
            <StyledAccordion onChange={handleChange} aria-label={businessGroup.name}>
                <StyleAccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className={cx({ 'accordion-bgc': isExpanded})}
                >
                    <StyleBusinessGroupListItemTitle>
                        <div className="business-group-log">
                            {businessGroup.photoURL ? (
                                // eslint-disable-next-line jsx-a11y/alt-text
                                <img className="business-group-logo" src={businessGroup.photoURL} />
                            ) : (
                                <DefaultBusinessIcon className="default-business-log" />
                            )}
                        </div>

                        <div className="business-group-list-description">
                            <div className="business-name" aria-label={businessGroup.name}>{businessGroup.name}</div>

                            <div className="description" aria-label={businessGroup.categoryName ||businessGroup.categoryTags || ""}>
                                {businessGroup.categoryName ? businessGroup.categoryName : businessGroup.categoryTags}
                            </div>
                        </div>
                    </StyleBusinessGroupListItemTitle>
                </StyleAccordionSummary>
                <StyleAccordionDetails>
                    {isFetchMore && <LinearProgress />}
                    {businessDisplayUnitList.map((businessDisplayUnit) => {
                        return (
                            // eslint-disable-next-line react/jsx-key
                            <div className={cx("business-list-unit-item-bgc")}>
                                <BusinessListUnitItem
                                    businessDisplayUnit={businessDisplayUnit}
                                    onSelect={onSelect}
                                />
                            </div>
                        );
                    })}
                    <div className="no-business-text">
                        {!isFetchMore && businessDisplayUnitList.length === 0 ? 'No Business' : ''}
                    </div>
                </StyleAccordionDetails>
            </StyledAccordion>
        </StyledBusinessGroupListItem>
    );
};
export default BusinessGroupListItem;
